import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "timeline" }
const _hoisted_2 = { class: "timeline-group__title" }
const _hoisted_3 = { class: "timeline-item" }
const _hoisted_4 = { class: "timeline-item__left" }
const _hoisted_5 = { class: "timeline-item__right" }
const _hoisted_6 = { class: "timeline-item__icon" }
const _hoisted_7 = { class: "timeline-item__detail" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "timeline-group"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_TranslatedText = _resolveComponent("TranslatedText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (group, groupIndex) => {
      return (_openBlock(), _createElementBlock("div", {
        key: groupIndex,
        class: "timeline-group"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h6", null, _toDisplayString(group.title), 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item, itemIndex) => {
          return (_openBlock(), _createElementBlock("div", { key: itemIndex }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", null, _toDisplayString(item.time), 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: item.icon
                  }, null, 8, ["icon"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_TranslatedText, {
                      path: item.text
                    }, null, 8, ["path"])
                  ]),
                  (item.notificationText)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createVNode(_component_TranslatedText, {
                          path: item.notificationText
                        }, null, 8, ["path"])
                      ]))
                    : _createCommentVNode("", true),
                  (item.subText)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode(_component_TranslatedText, {
                          path: item.subText
                        }, null, 8, ["path"])
                      ]))
                    : _createCommentVNode("", true),
                  (item.hasAction?.action)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _withModifiers(($event: any) => (_ctx.handleActionClick(item.hasAction?.action)), ["prevent"]),
                          class: "timeline-item__action-link"
                        }, [
                          _createVNode(_component_TranslatedText, {
                            path: item.hasAction?.actionText
                          }, null, 8, ["path"])
                        ], 8, _hoisted_11)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]))
        }), 128))
      ]))
    }), 128)),
    (_ctx.groups && _ctx.groups.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "timeline-group__title" }, null, -1)
        ]))]))
      : _createCommentVNode("", true)
  ]))
}